// Every "Show me how" button uses this one value.
export const AFFILIATE_LINK = "https://stan.store/affiliates/1fd2c776-51b7-4548-ad75-e32ffb019acb";
export const AFFILIATE_LINK_IS_PLACEHOLDER = AFFILIATE_LINK.startsWith("[INSERT");
export const CTA_TEXT = "Show me how";
